<template>
  <form
    ref="form"
    data-url="/organizations"
    class="mt-5 mb-0"
    :class="{ 'loading-opacity': preloader }"
  >
    <fieldset class="form-group">
      <div class="row">
        <legend class="col-12 col-form-label text-primary pt-0 mb-3">
          <h5>{{ $t("new_location") }}</h5>
        </legend>

        <div class="col-md-6">
          <div class="form-group">
            <label>Nombre</label>
            <app-input
              type="text"
              v-model="inputs.name"
              placeholder="Ingrese su nombre"
              :required="true"
              :disabled="disabled"
            />
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label>Razón Social</label>
            <app-input
              type="text"
              placeholder="Ingrese la razon social"
              v-model="inputs.business_name"
              :required="true"
              :disabled="disabled"
            />
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group mb-2 mb-md-0">
            <label>País</label>
            <app-input
              type="select"
              v-model="inputs.country_id"
              :required="true"
              :list="[
                { id: '', value: this.$t('select_option') },
                ...this.$store.state.common.countries,
              ]"
              :disabled="disabled"
            />
          </div>
        </div>

        <div
          class="col-md-6"
          v-if="inputs.country_id && provinceList.length <= 1"
        >
          <div class="form-group">
            <label>Ciudad</label>
            <app-input
              type="text"
              v-model="inputs.city"
              placeholder="Ingrese la ciudad"
              :required="true"
              :disabled="disabled"
            />
          </div>
        </div>

        <div class="col-md-6" v-if="provinceList.length > 1">
          <div class="form-group mb-2 mb-md-0">
            <label>Provincia</label>
            <app-input
              type="select"
              v-model="inputs.province_id"
              :required="true"
              :list="[
                { id: '', value: this.$t('select_option') },
                ...provinceList,
              ]"
              :disabled="disabled"
            />
          </div>
        </div>

        <div class="col-md-6" v-if="provinceList.length > 1">
          <div class="form-group mb-2 mb-md-0">
            <label>Ciudad</label>
            <app-input
              type="select"
              v-model="inputs.canton_id"
              :required="true"
              :list="[
                { id: '', value: this.$t('select_option') },
                ...cantonList,
              ]"
              :disabled="disabled"
            />
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group mb-2 mb-md-0">
            <label>Dirección</label>
            <app-input
              type="textarea"
              v-model="inputs.address"
              :required="true"
              :disabled="disabled"
            />
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label>Responsable</label>
            <app-input
              type="text"
              v-model="inputs.legal_representative"
              placeholder="Ingrese el responsable"
              :required="true"
              :disabled="disabled"
            />
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label>Teléfono</label>
            <app-input
              type="tel-input"
              v-model="inputs.phone"
              placeholder="Ingrese su numero de telefono"
              :required="true"
              :disabled="disabled"
            />
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label>E-mail</label>
            <app-input
              type="email"
              v-model="inputs.email"
              placeholder="Ingrese su email"
              :required="true"
              :disabled="disabled"
            />
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label>Código Postal</label>
            <app-input
              type="text"
              v-model="inputs.postal_code"
              :required="true"
              :disabled="disabled"
            />
            <a href="https://www.codigopostal.gob.ec/" target="_blank"
              >Consultar Código Postal Ecuador</a
            >
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label>Pág. Web</label>
            <app-input
              type="text"
              v-model="inputs.web"
              placeholder="Ingrese su pagina web"
              :required="true"
              :disabled="disabled"
            />
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group mb-2 mb-md-0">
            <label>Actividad Principal</label>
            <app-input
              type="textarea"
              v-model="inputs.main_activity"
              :required="true"
              :disabled="disabled"
            />
          </div>
        </div>

        <div class="col-md-12" v-if="showCriticalActivities">
          <div class="form-group">
            <input
              type="checkbox"
              v-model="inputs.critical_location"
              :disabled="disabled"
            />
            <label>{{ $t("critical_location") }}</label>
          </div>
        </div>

        <div
          class="col-md-12"
          v-if="inputs.critical_location && showCriticalActivities"
        >
          <table id="critical-activities">
            <tr v-for="(value, key) in inputs.critical_activities" :key="key">
              <td class="title" :rowspan="0" v-if="key === 0">
                {{ $t("critical_activities_performed") }}
              </td>
              <td>{{ key + 1 }}</td>
              <td class="name">
                {{ value.critical_activity.name }}
              </td>
              <td class="is-checked">
                <input
                  type="checkbox"
                  v-model="value.is_checked"
                  :disabled="disabled"
                />
              </td>
            </tr>
          </table>
        </div>

        <div class="col-12 mt-3" v-if="!disabled">
          <button
            type="submit"
            class="btn btn-primary mr-2"
            @click.prevent="submit"
          >
            {{ $t("save") }}
          </button>
        </div>
      </div>
    </fieldset>
  </form>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import * as actions from "#/Accreditation/Resources/assets/js/apiUrl";
export default {
  name: "OrganizationBranch",
  mixins: [FormMixin],
  data() {
    return {
      preloader: false,
      inputs: {},
      provinceList: [],
      cantonList: [],
    };
  },
  computed: {
    disabled() {
      return (
        this.$store.state.accreditation.app != null &&
        this.$store.state.accreditation.app.status.code != "100"
      );
    },
    showCriticalActivities() {
      return (
        this.$store.state.accreditation.app != null &&
        ![1, 3].includes(
          this.$store.state.accreditation.app.accreditation_activity_id
        )
      );
    },
  },
  created() {
    this.data();
  },
  watch: {
    "inputs.country_id": function () {
      this.provinceList = this.$store.getters.getProvinces(
        this.inputs.country_id
      );
    },

    "inputs.province_id": function () {
      this.cantonList = this.$store.getters.getCantons(this.inputs.province_id);
    },

    "$store.state.common.countries": function () {
      this.provinceList = this.$store.getters.getProvinces(
        this.inputs.country_id
      );
      this.cantonList = this.$store.getters.getCantons(this.inputs.province_id);
    },
  },
  methods: {
    beforeSubmit() {
      this.preloader = true;
    },

    submit() {
      this.inputs.establishment_type = "B";
      this.inputs.accreditation_application_id = this.$store.state.accreditation.id;
      this.save(this.inputs);
    },

    afterSuccess(res) {
      // this.$toastr.s(res.data.message);
      const { data } = res.data;
      this.inputs = data;
      this.$toastr.s(this.$t("updated_success"));
    },

    afterFinalResponse() {
      this.preloader = false;
    },

    afterError(res) {
      this.$toastr.e(res.data.message);
    },

    data() {
      this.preloader = true;

      this.axiosGet(
        `${actions.ORGANIZATIONS}/branch?accreditation_application_id=${this.$store.state.accreditation.id}`
      )
        .then((response) => {
          if (response.status == 200) {
            this.inputs = response.data.branch ? response.data.branch : {};
            if (this.inputs.critical_activities == null) {
              this.inputs.critical_activities = response.data.critical_activities.map(
                (item) => {
                  return {
                    critical_activity_id: item.id,
                    is_checked: 0,
                    critical_activity: { name: item.name },
                  };
                }
              );
            }
          }
        })
        .catch((error) => {
          console.log("OrganizationBranch: " + error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
  },
};
</script>
<style lang="css">
#critical-activities {
  width: 100%;
}
#critical-activities tr {
  border: 1px solid gray;
}
#critical-activities td {
  padding: 0.8rem;
}
#critical-activities .title {
  background-color: gray;
  width: 20%;
  text-align: center;
}
#critical-activities .name {
  width: 70%;
}
#critical-activities .is-checked {
  width: 5%;
  text-align: center;
}
</style>